import React, { useEffect, useState } from 'react';
import './Dashboard.css';

const Dashboard = () => {
  const [stats, setStats] = useState({ total: 0, byStatus: {} });
  const [announcements, setAnnouncements] = useState([]);

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/api';
  const token = localStorage.getItem('token');

  useEffect(() => {
    const headers = { Authorization: `Bearer ${token || ''}` };

    const fetchStats = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/dashboard/stats`, { headers });
        if (!res.ok) throw new Error('Failed to fetch submission stats');
        const data = await res.json();
        setStats({
          total: Number(data.total || 0),
          byStatus: data.byStatus || {},
        });
      } catch (e) {
        console.error(e);
      }
    };

    const fetchAnnouncements = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/dashboard/announcements`, { headers });
        if (!res.ok) throw new Error('Failed to fetch announcements');
        const data = await res.json();
        setAnnouncements(Array.isArray(data) ? data : []);
      } catch (e) {
        console.error(e);
      }
    };

    fetchStats();
    fetchAnnouncements();
  }, [API_BASE_URL, token]);

  const statusEntries = Object.entries(stats.byStatus);

  return (
    <div className="dashboard-container">
      <div className="stats-grid">
        <div className="stats-box total-submissions">
          <h2>Total Proposals</h2>
          <p>{stats.total}</p>
        </div>

        {statusEntries.map(([label, count]) => (
          <div
            key={label}
            className={`stats-box status-${label.replace(/\s+/g, '-').toLowerCase()}`}
            title={label}
          >
            <h2>{label}</h2>
            <p>{count}</p>

          </div>
        ))}
      </div>

      <div className="announcement-section">
        <h2>Announcements</h2>
        <br />
        <div className="announcement-box">
          {announcements.length ? (
            announcements.map((a) => (
              <div key={a.id ?? a.title} className="announcement-item">
                <h3>{a.title}</h3>
                <p>{a.message}</p>
              </div>
            ))
          ) : (
            <p>No announcements at this time.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
